var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('span',{staticClass:"poweredBy"},[_vm._v("Powered by")]),_c('d-logo',{attrs:{"height":"20","primary-color":'#ccc',"secondary-color":'#ccc',"slogan":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }